import styled from "styled-components";

export const TooltipContainer = styled.div`
    background: white;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
`

export const MobileChartWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
`

export const ChartContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`